/* Ideas & how-to guide pages (2026-09-18): progressive enhancement for the
   guide-steps tab list and the guide-kit toggle. Without this file every
   step panel is visible and the kit files are simply shown/hidden by the
   [hidden] attribute the section rendered. */
(function () {
  'use strict';

  function enhanceSteps(root) {
    if (root.dataset.wwGuideReady) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (tabs.length < 2 || panels.length !== tabs.length) return;
    root.dataset.wwGuideReady = '1';
    root.classList.add('is-enhanced');

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        panels[i].hidden = !on;
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowRight': case 'ArrowDown': next = (i + 1) % tabs.length; break;
          case 'ArrowLeft': case 'ArrowUp': next = (i - 1 + tabs.length) % tabs.length; break;
          case 'Home': next = 0; break;
          case 'End': next = tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        select(next, true);
      });
    });

    /* optional progress footer + show-all toggle */
    var footer = root.querySelector('[data-ww-guide-footer]');
    var allLabel = root.querySelector('[data-ww-guide-all-label]');
    var allBox = root.querySelector('[data-ww-guide-all]');
    var status = footer && footer.querySelector('.ww-guide-steps__status');
    var nextBtn = footer && footer.querySelector('[data-ww-guide-next]');
    var current = 0;
    function lower(str) { return str ? str.charAt(0).toLowerCase() + str.slice(1) : ''; }
    function renderFooter() {
      if (!footer) return;
      var total = tabs.length;
      var short = panels[current].getAttribute('data-short') || '';
      status.textContent = footer.getAttribute('data-step-word') + ' ' + (current + 1) + ' of ' + total + (short ? ' \u00b7 ' + short : '');
      if (current < total - 1) {
        var nextShort = panels[current + 1].getAttribute('data-short') || tabs[current + 1].textContent.trim();
        nextBtn.hidden = false;
        nextBtn.textContent = footer.getAttribute('data-next-prefix') + ' ' + lower(nextShort) + ' \u2192';
      } else {
        nextBtn.hidden = true;
      }
    }
    var baseSelect = select;
    select = function (index, focus) { current = index; baseSelect(index, focus); renderFooter(); };
    tabs.forEach(function (tab, i) { tab.addEventListener('click', function () { current = i; renderFooter(); }); });
    if (footer) {
      footer.hidden = false;
      nextBtn.addEventListener('click', function () { select(Math.min(current + 1, tabs.length - 1), true); });
    }
    if (allLabel && allBox) {
      allLabel.hidden = false;
      allBox.addEventListener('change', function () { root.classList.toggle('is-all', allBox.checked); });
    }

    select(0, false);
  }

  function enhanceCopy(button) {
    if (button.dataset.wwGuideReady) return;
    button.dataset.wwGuideReady = '1';
    var source = document.getElementById(button.getAttribute('data-ww-guide-copy'));
    if (!source) return;
    var label = button.textContent;
    button.addEventListener('click', function () {
      var text = source.textContent;
      var done = function () {
        button.textContent = button.dataset.labelCopied || 'Copied!';
        setTimeout(function () { button.textContent = label; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { fallback(); });
      } else { fallback(); }
      function fallback() {
        var range = document.createRange(); range.selectNodeContents(source);
        var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
        try { document.execCommand('copy'); done(); } catch (e) { /* leave the text selected */ }
      }
    });
  }

  function enhanceKit(root) {
    var toggle = root.querySelector('[data-ww-guide-kit-toggle]');
    if (!toggle || toggle.dataset.wwGuideReady) return;
    toggle.dataset.wwGuideReady = '1';
    var files = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!files) return;

    function setOpen(open) {
      files.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? toggle.dataset.labelOpen : toggle.dataset.labelClosed;
    }
    toggle.addEventListener('click', function () { setOpen(files.hidden); });
    root.wwGuideOpenKit = function () { setOpen(true); };
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ww-guide-steps]'), enhanceSteps);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ww-guide-kit]'), enhanceKit);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ww-guide-copy]'), enhanceCopy);
  }

  /* hero "See the kit" button: expand the kit, then let the anchor scroll */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-ww-guide-open-kit]');
    if (!link) return;
    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#') return;
    var kit = document.getElementById(hash.slice(1));
    if (kit && kit.wwGuideOpenKit) kit.wwGuideOpenKit();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* theme editor: sections re-render when settings change */
  document.addEventListener('shopify:section:load', init);
})();
